<template>
  <transition name="modal">
    <div id="ecommerce_product_edit" class="modal-mask">
      <div class="modal-wrapper" role="document" style="overflow-y:auto;position:absolute">
        <div
          class="modal-container"
          :class="{'modal-dialog': !isFixed , 'modal-fixed modal-lg': isFixed}"
        >
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <a
                href="javascript:void(0)"
                class="close"
                @click="$emit('close')"
                data-dismiss="modal"
                aria-label="Close"
              >
                <vue-simple-svg
                  :filepath="'/static/img/assets/_global/Close.svg'"
                  width="50px"
                  height="auto"
                  class="icon"
                />
              </a>
              <div class="row" style="margin-bottom: 0">
                <div class="col s12">
                  <slot name="header"></slot>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <slot name="body"></slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <div style="margin-bottom: 25px;">
                  <v-btn outline grey @click="$emit('close')" data-dismiss="modal">{{$t('cancel')}}</v-btn>
                  <v-btn primary depressed @click="$emit('onSave')" >{{$t('Save')}}</v-btn>
                
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    isFixed: {
      default: false,
      type: Boolean
    }
  },
  mounted: function () {
    var vm = this
    document.addEventListener('keydown', e => {
      if (e.keyCode === 27) {
        vm.$emit('close')
      }
    })
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/ModalDialog.vue